import AddIntoNewsletterContainer from './AddIntoNewsletterContainer';

export default AddIntoNewsletterContainer;
